import React from 'react'

export const IconMinus = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="currentColor" viewBox="0 0 24 24" xmlSpace="preserve" {...props}>
      <path d="M19 13H5a1 1 0 010-2h14a1 1 0 010 2z" />
    </svg>
  )
}
